"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EOtpHandlerChannelErrorStatus = void 0;
/**
 * Типы ошибок в эвенте error отправялемых из каналов (opt-channel) в otp-handler
 */
var EOtpHandlerChannelErrorStatus;
(function (EOtpHandlerChannelErrorStatus) {
    /**
     * Внутренняя ошибка сервиса либо ошибка
     * в другом сервисе к которому обращается otp-channel
     */
    EOtpHandlerChannelErrorStatus["serverError"] = "serverError";
    /**
     * Отправка пользователю не удалась
     */
    EOtpHandlerChannelErrorStatus["sendError"] = "sendError";
    /**
     * Нет подходящих настроек для канала
     *
     * Происходит при передаче настроек в opt-channel из otp-handler
     * и не было не одной подходящей настройки
     */
    EOtpHandlerChannelErrorStatus["noSuitableSettings"] = "noSuitableSettings";
    /**
     * Ичерпано количество попыток
     *
     * Происходит когда используется внешний сервис и он прислал
     * ошибку на исчерпание количество попыток
     */
    EOtpHandlerChannelErrorStatus["attemptsExpired"] = "attemptsExpired";
    /**
     * Срок действия запроса истёк
     *
     * Происходит когда используется внешний сервис и он прислал
     * ошибку истечения срока действия запроса
     */
    EOtpHandlerChannelErrorStatus["sessionTimeOut"] = "sessionTimeOut";
    /**
     * Данные в эвенте отправленные из otp-handler в otp-channel неправильные
     */
    EOtpHandlerChannelErrorStatus["invalidData"] = "invalidData";
    /**
     * Сессия не найдена
     *
     * Происходит когда такой сессии не существует либо закочилось время жизни сессии
     */
    EOtpHandlerChannelErrorStatus["sessionNotFound"] = "sessionNotFound";
    /**
     * Такая сессия уже существует
     */
    EOtpHandlerChannelErrorStatus["sessionAlreadyExists"] = "sessionAlreadyExists";
})(EOtpHandlerChannelErrorStatus || (exports.EOtpHandlerChannelErrorStatus = EOtpHandlerChannelErrorStatus = {}));
//# sourceMappingURL=OtpHandlerChannelErrorStatus.enum.js.map